module.exports = __webpack_public_path__ + "img/kino_kunsthalle_2_a.80ca411e.jpg";